export const selectHasGlobalSettings = state => Boolean(state.globalSettings.data);

export const selectGlobalSettings = state => state.globalSettings.data;
